// extracted by mini-css-extract-plugin
export default {"skeleton-segmented-control":"syJ3D"};